<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div
    class="overflow-x-scroll overflow-y-visible scrollbar-hide touch-pan-x w-full"
  >
    <woot-tabs
      :index="activeTabIndex"
      :border="false"
      class="w-full px-3 -mt-1 py-0 h-10"
      @change="onTabChange"
    >
      <woot-tabs-item
        v-for="(item, index) in items"
        :key="item.key"
        class="text-sm [&_a]:font-medium flex-shrink-0"
        :index="index"
        :name="item.name"
        :count="item.count"
        is-compact
      />
    </woot-tabs>
  </div>
</template>

<style scoped>
:deep(ul) {
  overflow-x: auto !important;
  overflow-y: visible !important;
  flex-wrap: nowrap !important;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}

:deep(ul::-webkit-scrollbar) {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

:deep(li) {
  flex-shrink: 0 !important;
}

/* Ocultar botones de scroll en mobile */
@media (max-width: 640px) {
  :deep(button) {
    display: none !important;
  }
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Ocultar barra de scroll del contenedor externo */
.scrollbar-hide::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
</style>
